import { equalizeHeights } from '../../utils/equalize-heights';

const ROOT_SELECTOR = '.card-grid';
const GRID_SELECTOR = '.card-grid__grid';
const CARD_SELECTOR = '.card-grid__card';

export function initCardGrid(): void {
  document.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach(initCardGridRoot);
}

function initCardGridRoot(root: HTMLElement): void {
  const grid = root.querySelector<HTMLElement>(GRID_SELECTOR);
  if (!grid) return;

  function equalizeCards(): void {
    equalizeHeights(root.querySelectorAll<HTMLElement>(CARD_SELECTOR));
  }

  equalizeCards();
  window.addEventListener('resize', equalizeCards);

  if (typeof window.ResizeObserver !== 'undefined') {
    const resizeObserver = new window.ResizeObserver(() => equalizeCards());
    resizeObserver.observe(grid);
  }

  root.querySelectorAll<HTMLImageElement>(`${CARD_SELECTOR} img`).forEach((img) => {
    if (!img.complete) {
      img.addEventListener('load', () => equalizeCards(), { once: true });
    }
  });
}
